<div class="left-menu-container text" outsideListener (clickOutside)="clickOutside($event)">
  <ng-container [ngSwitch]="['b500'] | getProductName">
    <ng-container *ngSwitchCase="'b500'">
      <div class="left-menu-header">
        <div class="left-side">{{ 'Search' | t }}</div>
        <div class="right-side" (click)="closeLeftMenu()">
          <image-loader-utils url="close" extraClasses="close-icon"></image-loader-utils>
        </div>
      </div>
      <div class="left-menu-sports-vertical">
        <div class="left-menu-sports-vertical-item" (click)="this._UiHelper.closeDimmer()" routerLink="/search">
          <image-loader-utils url="search" extraClasses="left-menu-verticalsvg"></image-loader-utils>
          <div class="vertical-sport-name">{{ 'Search' | t }}</div>
        </div>
      </div>
    </ng-container>
  </ng-container>
  <div class="left-menu-header">
    <div class="left-side">{{ 'b3000_Quick_menu' | t }}</div>
    <ng-container [ngSwitch]="['b500'] | getProductName">
      <ng-container *ngSwitchCase="'b500'"></ng-container>
      <ng-container *ngSwitchDefault>
        <div class="right-side" (click)="closeLeftMenu()">
          <image-loader-utils url="close" extraClasses="close-icon"></image-loader-utils>
        </div>
      </ng-container>
    </ng-container>
  </div>
  <div class="left-menu-sports-vertical">
    <div
      *ngFor="let leftItem of leftMenuData"
      class="left-menu-sports-vertical-item"
      (click)="getCountriesBySportsID(leftItem.sportId, leftItem.index)"
      [routerLink]="['/allsports/' + leftItem.routeId]">
      <image-loader-utils [url]="leftItem.svgPath" extraClasses="left-menu-verticalsvg"></image-loader-utils>
      <div class="vertical-sport-name">{{ leftItem.title | t }}</div>
    </div>
  </div>
  <div class="left-menu-general-vertical">
    <ng-container *ngFor="let leftItem of this.leftMenuGeneralDataRebuild(this.leftMenuGeneralData)">
      <div *ngIf="leftItem.standingType; else elseBlock" class="left-menu-general-vertical-item" (click)="openStats(leftItem.standingType)">
        <div class="general-vertical-sport-icon">
          <image-loader-utils [url]="leftItem.svgPath" extraClasses="left-menu-verticalsvg general-vertical-sport-svg"></image-loader-utils>
        </div>
        <div class="general-vertical-sport-name">
          {{ leftItem.title | t }}
        </div>
      </div>
      <ng-template #elseBlock>
        <div class="left-menu-general-vertical-item" [routerLink]="[leftItem.routerLink]">
          <div class="general-vertical-sport-icon">
            <image-loader-utils [url]="leftItem.svgPath" extraClasses="left-menu-verticalsvg general-vertical-sport-svg"></image-loader-utils>
          </div>
          <div class="general-vertical-sport-name">
            {{ leftItem.title | t }}
          </div>
        </div>
      </ng-template>
    </ng-container>
  </div>
  <div class="timer-container">
    {{ narvbarDateTime }}
  </div>
</div>
